(() => {
  'use strict';
  if (window.idealPlpSwipeGuardInstalled) return;
  window.idealPlpSwipeGuardInstalled = true;

  const cardSelector = '.productgrid--item, [data-product-item]';
  const addSelector = 'button[data-quick-buy], button[data-quickshop-slim], button[data-ss-quick-buy], button[data-product-atc]';
  let gesture = null;

  function buttonFor(target) {
    if (!(target instanceof Element)) return null;
    const button = target.closest(addSelector);
    return button && button.closest(cardSelector) ? button : null;
  }

  function start(event, point, id) {
    gesture = {
      button: buttonFor(event.target), id,
      x: point.clientX, y: point.clientY,
      moved: false, cancelled: false, released: false,
      time: performance.now()
    };
  }

  function update(point, id, released) {
    if (!gesture || gesture.id !== id) return;
    if (Math.hypot(point.clientX - gesture.x, point.clientY - gesture.y) >= 12) gesture.moved = true;
    if (!released) return;
    gesture.released = true;
    gesture.time = performance.now();
    const bounds = gesture.button?.getBoundingClientRect();
    if (bounds && (point.clientX < bounds.left || point.clientX > bounds.right ||
      point.clientY < bounds.top || point.clientY > bounds.bottom)) gesture.cancelled = true;
  }

  function cancel(id) {
    if (!gesture || gesture.id !== id) return;
    gesture.cancelled = true;
    gesture.time = performance.now();
  }

  function invalid(button) {
    return gesture && performance.now() - gesture.time <= 1200 &&
      (gesture.button !== button || !gesture.released || gesture.moved || gesture.cancelled);
  }

  function block(event) {
    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
  }

  if ('PointerEvent' in window) {
    window.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') {
        gesture = null;
        return;
      }
      if (event.isPrimary === false) {
        if (gesture) cancel(gesture.id);
        return;
      }
      start(event, event, event.pointerId);
    }, { capture: true, passive: true });
    window.addEventListener('pointermove', event => update(event, event.pointerId, false), { capture: true, passive: true });
    window.addEventListener('pointerup', event => update(event, event.pointerId, true), { capture: true, passive: true });
    window.addEventListener('pointercancel', event => cancel(event.pointerId), { capture: true, passive: true });
    window.addEventListener('touchend', event => {
      const button = buttonFor(event.target);
      if (button && invalid(button)) block(event);
    }, { capture: true, passive: false });
  } else {
    window.addEventListener('touchstart', event => {
      if (event.touches.length !== 1) {
        if (gesture) cancel(gesture.id);
        return;
      }
      const point = event.touches[0];
      start(event, point, point.identifier);
    }, { capture: true, passive: true });
    window.addEventListener('touchmove', event => {
      for (const point of event.changedTouches) update(point, point.identifier, false);
    }, { capture: true, passive: true });
    window.addEventListener('touchend', event => {
      for (const point of event.changedTouches) update(point, point.identifier, true);
      const button = buttonFor(event.target);
      if (button && invalid(button)) block(event);
    }, { capture: true, passive: false });
    window.addEventListener('touchcancel', event => {
      for (const point of event.changedTouches) cancel(point.identifier);
    }, { capture: true, passive: true });
  }

  window.addEventListener('scroll', () => {
    if (gesture && !gesture.released) gesture.moved = true;
  }, { capture: true, passive: true });
  window.addEventListener('keydown', event => {
    if (buttonFor(event.target) && (event.key === 'Enter' || event.key === ' ')) gesture = null;
  }, true);
  window.addEventListener('click', event => {
    const button = buttonFor(event.target);
    if (!button) return;
    const touchClick = event.pointerType === 'touch' || event.pointerType === 'pen' || event.sourceCapabilities?.firesTouchEvents;
    if ((event.detail === 0 && !touchClick) || (event.pointerType === 'mouse' && !touchClick)) return;
    if (invalid(button)) block(event);
    else gesture = null;
  }, true);
})();
